export const PARTICIPANT_LAYOUT_ACTIVE_SELECTOR = "[data-participant-layout-root]";

export function isParticipantLayoutActiveForGlobalMedia(
  documentRef = typeof document !== "undefined" ? document : null
) {
  return Boolean(documentRef?.querySelector?.(PARTICIPANT_LAYOUT_ACTIVE_SELECTOR));
}
